export class HisSearchCriteriaSetRequest {

    configFile: string;
    context: string;
    flowName: string;

    constructor( configFile: string, context: string, flowName: string ) {
        this.configFile = configFile;
        this.context = context;
        this.flowName = flowName;
    }
}
